import { useState } from "react"
import { Dropdown } from "react-bootstrap"
import { FilterGradeLevel, ReviewGradeType } from "shared/types/science35Types"
import Modal from "react-bootstrap/Modal"
import Button from "react-bootstrap/Button"

interface Props {
    grades: Readonly<FilterGradeLevel[]>
    selectedGrades: ReviewGradeType[]
    onSelect: (selectedGrades: ReviewGradeType[]) => void
}

const SelectGradeLevelDropdown = ({ grades, selectedGrades, onSelect } : Props) => {
    const validGradeLevels = grades.filter(grade => grade.isValid).map(grade => grade.grade)

    const [modal, setModal] = useState<"buy-license-modal" | null>(null)
    return (
        <>
            <Dropdown className="text-start">
                <Dropdown.Toggle variant="transparent" className="text-theme border rounded border-theme">
                    {selectedGrades.length === 0 ? 
                    <span><i className="fa-solid fa-graduation-cap" /> Select Grade</span> : 
                    <span>{selectedGrades.length} {selectedGrades.length > 1 ? 'grades' : 'grade'} selected</span>}
                </Dropdown.Toggle>
                <Dropdown.Menu style={{ zIndex: 1050 }}>
                    <Dropdown.Item
                        onClick={(e) => {
                            e.stopPropagation()
                            const allSelected = selectedGrades.length === validGradeLevels.length
                            const newSelectedGrades = allSelected ? [] : [...validGradeLevels]
                            onSelect(newSelectedGrades)
                        }}>
                        <input
                            readOnly
                            type="checkbox"
                            checked={selectedGrades.length === validGradeLevels.length}
                            className="pe-none"
                        />
                        <span className="ps-3">Select All</span>
                    </Dropdown.Item>
                    {grades.map(grade => {
                        return <Dropdown.Item
                                onClick={(e) => {
                                    e.stopPropagation()
                                    if (!grade.isValid) {
                                        setModal("buy-license-modal")
                                        return
                                    }
                                    const newSelectedGrades = selectedGrades.includes(grade.grade) ? selectedGrades.filter(item => item !== grade.grade) : [...selectedGrades, grade.grade]
                                    onSelect(newSelectedGrades)
                                }}
                            >
                                <input
                                    readOnly
                                    type="checkbox"
                                    checked={selectedGrades.includes(grade.grade)}
                                    disabled={!grade.isValid}
                                    className="pe-none"
                                />
                                <span className={`ps-3 ${!grade.isValid ? "text-muted" : ""}`}>{grade.grade}</span>
                            </Dropdown.Item>
                    })}
                </Dropdown.Menu>
            </Dropdown>
            <Modal show={modal === "buy-license-modal"} cen size="lg" style={{ zIndex: 1061 }} centered>
                <Modal.Header>
                    <Modal.Title className="w-100">Purchase License</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p className="text-center">Please contact STEM Sims at sales@stemsims.com to purchase a license for this grade level.</p>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary" onClick={() => setModal(null)}>Close</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default SelectGradeLevelDropdown
